import parse from 'date-fns/parse';
import format from 'date-fns/format';
import getYear from 'date-fns/getYear';

const TWEET_DATE_FORMAT = 'EEE MMM dd HH:mm:ss XX y';

export function parseTweetDate(tweetDate) {
  return parse(tweetDate, TWEET_DATE_FORMAT, new Date());
}

export function formatTweetDate(tweetDate) {
  const currentYear = getYear(new Date());
  const tweetYear = getYear(tweetDate);
  return format(tweetDate, currentYear === tweetYear ? 'MMM d' : 'MMM d, yyyy');
}

export function formatTwitterSearchDate(date) {
  return format(date, 'yyyy-MM-dd');
}

// https://developer.twitter.com/en/docs/twitter-api/v1/accounts-and-users/user-profile-images-and-banners
export function biggerProfileImageUrl(url) {
  return url.replace(
    /(http|https)(.+)_(?:\w+?)\.(jpg|png)$/,
    'https$2_bigger.$3'
  );
}

export function twitterSearchUrl(termsQuery, since, until) {
  const sinceQuery = since ? `since:${formatTwitterSearchDate(since)}` : '';
  const untilQuery = until ? `until:${formatTwitterSearchDate(until)}` : '';
  const query = encodeURIComponent(`${termsQuery} ${sinceQuery} ${untilQuery}`);
  return `https://twitter.com/search?q=${query}`;
}
